export default __webpack_public_path__ + "static/media/market_info.18c2a1a3.svg";